/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemArScanningStatusFromJSON(json) {
    return WallItemArScanningStatusFromJSONTyped(json, false);
}
export function WallItemArScanningStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inResponseToWallItemId': !exists(json, 'in_response_to_wall_item_id') ? undefined : json['in_response_to_wall_item_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'trackableUpdatesProvider': !exists(json, 'trackable_updates_provider') ? undefined : json['trackable_updates_provider'],
    };
}
export function WallItemArScanningStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'in_response_to_wall_item_id': value.inResponseToWallItemId,
        'status': value.status,
        'trackable_updates_provider': value.trackableUpdatesProvider,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemArScanningStatusStatus;
(function (WallItemArScanningStatusStatus) {
    WallItemArScanningStatusStatus["ERROR"] = "TRACKABLE_SCANNING_STATUS_ERROR";
    WallItemArScanningStatusStatus["INVALID"] = "TRACKABLE_SCANNING_STATUS_INVALID";
    WallItemArScanningStatusStatus["SCANNING"] = "TRACKABLE_SCANNING_STATUS_SCANNING";
})(WallItemArScanningStatusStatus || (WallItemArScanningStatusStatus = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArScanningStatusTrackableUpdatesProvider;
(function (WallItemArScanningStatusTrackableUpdatesProvider) {
    WallItemArScanningStatusTrackableUpdatesProvider["DATATRACK"] = "STREAMING_MESSAGE_PROVIDER_DATA_TRACK";
    WallItemArScanningStatusTrackableUpdatesProvider["INVALID"] = "STREAMING_MESSAGE_PROVIDER_INVALID";
    WallItemArScanningStatusTrackableUpdatesProvider["TWILIOSYNCSTREAM"] = "STREAMING_MESSAGE_PROVIDER_TWILIO_SYNC_STREAM";
})(WallItemArScanningStatusTrackableUpdatesProvider || (WallItemArScanningStatusTrackableUpdatesProvider = {}));
//# sourceMappingURL=WallItemArScanningStatus.js.map